import {Component, OnInit} from '@angular/core';

@Component({
             selector: 'app-dialog-events',
             templateUrl: './dialog-events.component.html',
             styleUrls: ['./dialog-events.component.scss']
           })
export class DialogEventsComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
